import "@fontsource/poppins/300.css";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import 'lite-youtube-embed';
import 'lite-youtube-embed/src/lite-yt-embed.css';
import './js/sweetalert.js';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  function backToTopScroll() {
    if ($(window).scrollTop() > 100) {
      $('#backToTop').addClass("not-top");
    } else {
      $('#backToTop').removeClass("not-top");
    }
  }
  $(window).on('scroll', function () {
    headerScroll();
    backToTopScroll();
  });

  $('.mega-region__title').on('click', function () {
    $(this).toggleClass('active');
    $(this).siblings('.mega-region-group').toggleClass('active');
  });

  // index slider
  var indexSocial = new Swiper('#indexSlider', {
    effect: 'fade',
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    autoplay: true,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });

  // plans slider
  var plansSlider = new Swiper('#plansSlider', {
    grabCursor: true,
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
    breakpoints: {
      767: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  // footer license
  $('.footer-license').on('click', function() {
    $(this).toggleClass('expanded');
  });

  // slide tabs
  var slide_tabs = new Swiper('#slide_tabs', {
    slidesPerView: 'auto',
    speed: 1000,
    navigation: {
      nextEl: '.slide-tab-next',
      prevEl: '.slide-tab-prev',
    },
  });

  // sweetalert
  $("[data-swal]").on('click', async function (event) {
    event.preventDefault();
    const Swal = (await import('sweetalert2')).default;
    let id = $(this).data('swal');
    let data = $("[data-id=" + id + "]").html();
    Swal_lg.fire({
      html: '<div class="swal-details">' + data + '</div>',
    });
  });
});

//Header
document.addEventListener("DOMContentLoaded", () => {
  const toggleBtn = document.querySelector(".menu-toggle-btn");
  const closeBtn = document.querySelector(".menu-close");
  const overlay = document.querySelector(".menu-overlay");

  toggleBtn?.addEventListener("click", () => {
    overlay.style.display = 'block';
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.3s ease-in-out';

    setTimeout(() => {
      overlay.classList.add("open");
      overlay.style.opacity = '1';

      const showZoomInFastElements = document.querySelectorAll('.show-zoom-in-fast');
      if (showZoomInFastElements.length && window.gsap) {
        gsap.set(showZoomInFastElements, { opacity: 0, scale: 0.6 });
        gsap.to(showZoomInFastElements, {
          ease: 'power1.inOut',
          opacity: 1,
          scale: 1,
          stagger: 0.1
        });
      }
    }, 10);
  });

  closeBtn?.addEventListener("click", () => {
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.3s ease-in-out';

    // 動畫完成後隱藏元素
    setTimeout(() => {
      overlay.classList.remove("open");
      overlay.style.display = 'none';
    }, 300);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");

  window.addEventListener("scroll", () => {
    if (window.scrollY > 10) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
});

//Back to Top
document.addEventListener("DOMContentLoaded", function () {
  const backToTopBtn = document.getElementById("backToTopBtn");

  backToTopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});

//tab
document.querySelectorAll('.tab-item').forEach(tab => {
  tab.addEventListener('click', () => {

    document.querySelectorAll('.tab-item').forEach(item => item.classList.remove('active'));
    tab.classList.add('active');


    const target = tab.dataset.tab;
    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.remove('active');
    });
    document.getElementById(target).classList.add('active');
  });
});

//country
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".hero-tabs li");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");


      const targetSelector = this.getAttribute("data-tab-target");
      const targetSection = document.querySelector(targetSelector);
      if (targetSection) {
        window.scrollTo({
          top: targetSection.offsetTop - 100,
          behavior: "smooth"
        });
      }
    });
  });
});

window.addEventListener('load', () => {
  const mapImage = document.getElementById('mapImage');
  if (!mapImage) {
    // 如果不在 schools 頁面，直接返回，不執行相關程式碼
    return;
  }

  const buttons = document.querySelectorAll('.map-button');
  const cards = document.querySelectorAll('.school-cards');

  function updateRegion(region, mapSrc) {

    mapImage.src = `/images/school/${mapSrc}.png`;


    buttons.forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.map-button[data-map-region="${region}"]`)?.classList.add('active');


    cards.forEach(card => {
      if (card.dataset.region === region) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });
  }


  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const region = btn.dataset.mapRegion;
      const mapSrc = btn.dataset.map;
      updateRegion(region, mapSrc);
    });
  });

  updateRegion('north', 'map-north');
});
